define('helpers/property-helper',[
    'evertrue',
    'jquery',
    'underscore'
], function(EverTrue, $, _){

    var PropertyHelper = function() {
        var self = this,
            _propertyLoop;

        // Loop through each schema object and pull out the properties,
        // Set the list and containing_object data to parent_object
        _propertyLoop = function (schema, callback) {
            _.each($.extend(true, {}, schema), function(list){
                var properties,
                    parent = $.extend(true, {}, list);

                if (list.containing_object && list.containing_object.properties) {
                    properties = list.containing_object.properties;
                } else if (list.properties) {
                    properties = list.properties;
                } else {
                    properties = [list];
                }

                if (parent.containing_object) delete parent.containing_object.properties;
                _.each(properties, function(prop){
                    if (!prop.deleted) {
                        prop.list_name = list.name;
                        prop.object_name = (list.containing_object) ? list.containing_object.name : undefined;
                        prop.parent_object = $.extend(true, {}, parent);

                        callback.apply(self, [list, prop]);
                    }
                });
            });
        };

        self.toPropLookup = function(data){
            var lookup = {};

            _propertyLoop(data, function(list, prop){

                if (prop.name == "value")
                    lookup[prop.list_name] = prop;
                else
                    lookup[prop.name] = prop;
            });

            return lookup;
        };

        self.toPropArray = function(schema){
            var array = [];

            _propertyLoop(schema, function(list, prop){
                array.push(prop);
            });

            return array;
        };

        self.toGroupLookup = function(schema, groupFlex){
            var lookup = {},
                properties = self.toPropLookup(schema),
                grouped = _.groupBy(properties, 'list_name');

            if (groupFlex) {
                lookup.$flex = self.toPropLookup(self.getFlex(schema));
            }

            return grouped;
        };

        self.getFlex = function(schema) {
            var flex = [];
            _propertyLoop(schema, function(list, prop){
                if (!list["default"] && !list["deleted"]) {
                    flex.push(list);
                }
            });
            return flex;
        };

        // This method gets all the property names in the Profile DNA json
        // in order to display potential errors from legacy or manual changes
        self.parsePropertyJSON = function(profileJSON) {
            var view = this,
                profile = [];

            if (profileJSON) {
                _.each(profileJSON.items, function(item){
                    if (item.subtitle1) profile.push(item.subtitle1.source);
                });
            }

            return profile;
        };

        self.getProfileJSON = function(product_label) {
            if (product_label) {
                var profileKey = "ET.Profile.Featured." + product_label.replace(" ", "") + ".Contacts";
                return EverTrue.DNA.get(profileKey);
            }
        };

        // TODO: Revert Logic to take object, array or group object
        // and parse them back into full Contacts object
        // self.toContactsObject = function(){}
    };

    return new PropertyHelper();
});

